import { getServices } from '~/db/services';
import { UserContentType } from '~/types/app';

export const useCategoryGetParamsFromRoute = (
  pageContextType: CategoryPageContextTypes
): UseCategoryGetParams => {
  const { $db } = useNuxtApp();
  const { getContentFromSlug } = useContentsHelper();

  const route = useRoute();

  const { mainContent } = useContents();

  const currentContent = ref<UserContent>();

  const { categoriesService } = getServices($db);

  const section = ref<Sections>();

  let isHome = false;

  switch (pageContextType) {
    case CategoryPageContextTypes.Home:
      currentContent.value = mainContent.value;
      section.value = Sections.InTheNews;
      isHome = true;
      break;
    default:
      section.value = route.params.section as Sections;
      currentContent.value = getContentFromSlug(
        route.params.lb_or_eval as string
      );
  }

  if (
    currentContent.value &&
    currentContent.value.type === UserContentType.UnDownloadedContent
  ) {
    currentContent.value = null;
  }

  const slug = ref<string>();

  slug.value = route.params.category as string;

  const load = async () => {
    if (
      currentContent.value &&
      currentContent.value.type !== UserContentType.UnDownloadedContent &&
      !slug.value
    ) {
      // We are on the root page (no slug category), asking for course&quiz content of the lb
      const root = await categoriesService.getByContentTypesAndLb(
        ['course&quiz', 'training', 'adventure'],
        currentContent.value.id
      );
      slug.value = root.slug;
    }
  };

  return {
    pageContextType,
    currentContent,
    section,
    slug,
    isStudyContent: false,
    baseCategory: null,
    isHome,
    load,
  };
};
